import { SpreadGroundImage } from 'editor/src/store/design/types';

export interface SpreadGroundImageScale {
  scaleX: number;
  scaleY: number;
}

// Compute the canvas-px scale to apply to a spread bg/fg image so its label
// rect aligns with the spread on canvas. When uniformScale is set, the
// smaller of the two raw axis scales is used for both, preserving the
// image's natural aspect (avoids stretching the product photo when the
// spread mm aspect doesn't match the image's label-rect px aspect).
export default function getSpreadGroundImageScale(
  image: SpreadGroundImage,
  spreadWidth: number,
  spreadHeight: number,
  mm2px: (size: number) => number,
  uniformScale = false,
): SpreadGroundImageScale {
  const rawScaleX = mm2px(spreadWidth) / image.width;
  const rawScaleY = mm2px(spreadHeight) / image.height;
  if (uniformScale) {
    const uniform = Math.min(rawScaleX, rawScaleY);
    return { scaleX: uniform, scaleY: uniform };
  }
  return { scaleX: rawScaleX, scaleY: rawScaleY };
}
